module.exports = __webpack_public_path__ + "media/images/search-dfdf61cf123cd2849555e06190c38bf2.svg";